import script from "./InputRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRadio.vue?vue&type=script&setup=true&lang=js"

import "./InputRadio.vue?vue&type=style&index=0&id=fe1b42d4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe1b42d4"]])

export default __exports__